module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<label class="b-input">\n	<span class="js-widget"  onclick=\'return new Widgets.Select({ bindingProperty: "keyContact" , values: "' + keyContacts + '" , label: L10N.get("b2b.costCodes.keyContact.code") })\'></span>\n</label>';

}
return __p
}